import { Box, Button } from '@mui/material'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import { TEXTFIELD_REQUIRED_LENGTH } from '~/common/constants'
import Dialog from '~/components/Dialog'
import { Field } from '~/components/Formik'

const AddNoteDialog = ({
  isOpenAddNoteModal,
  setIsOpenAddNoteModal,
  onSubmit,
}) => {
  const { t } = useTranslation(['mkt'])
  return (
    <Dialog
      open={isOpenAddNoteModal}
      title={t('common.notify')}
      onCancel={() => setIsOpenAddNoteModal(false)}
      noBorderBottom
    >
      {t('guest.dialog.addNoteModalTitle')}
      <Formik
        initialValues={{
          note: '',
        }}
        validationSchema={() =>
          Yup.object().shape({
            note: Yup.string().required(t('form.required')),
          })
        }
        onSubmit={onSubmit}
        enableReinitialize
      >
        {() => {
          return (
            <Form>
              <Field.TextField
                name="note"
                label={t('guest.note')}
                placeholder={t('guest.notePlaceholder')}
                inputProps={{
                  maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
                }}
                required
                multiline
                rows={3}
                sx={{ mt: 1 }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mt: 2,
                }}
              >
                <Button
                  color="grayF4"
                  sx={{ mr: 1 }}
                  onClick={() => setIsOpenAddNoteModal(false)}
                >
                  {t('common.no')}
                </Button>
                <Button color="primary" type="submit">
                  {t('common.yes')}
                </Button>
              </Box>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}

export default AddNoteDialog
